import React from "react";
//import { Divider } from "antd";
import TrackedWebsitesSelector from "./TrackedWebsitesSelector";
import LoadingIndicator from "../shared/LoadingIndicator/LoadingIndicator";
import DashboardSettingsTabs from "./DashboardSettingsTabs";
import "./DashboardSettings.less";

function DashboardSettingsLayout(props) {
  if (props.isLoading) {
    return <LoadingIndicator />;
  }
  return (
    <React.Fragment>
      <div className="dashboard-settings-header">
        <TrackedWebsitesSelector
          trackedWebsites={props.trackedWebsites}
          selectedWebsite={props.selectedWebsite}
          handleTrackedWebsiteChange={props.handleTrackedWebsiteChange}
        />
      </div>
      <DashboardSettingsTabs 
        push={props.push} 
        selectedWebsite={props.selectedWebsite} 
        selectedOption={props.selectedOption} />
    </React.Fragment>
  );
}

export default DashboardSettingsLayout;
